export default {
      id: "icon-bofaq-usage",
      viewBox: "0 0 66 66",
      url: __webpack_public_path__ + "icons.svg#icon-bofaq",
      toString: function () {
        return this.url;
      }
    }